module.exports = __webpack_public_path__ + "img/wallet-icon.98b3660.png";